import { createAction } from 'redux-actions';
import {
    SET_OPTION,
    SET_OPTIONLOADING
} from '../constants/actionTypes';
import { doGet, doPost } from '../utils/AjaxRequests'
import _ from 'lodash'
import { apiPrefixUrl } from '../utils/connection'
import { format, parse, isValid } from 'date-fns'
import {weeks} from '../utils/utils'

export const setOption = createAction(SET_OPTION)
export const setOptionLoading = createAction(SET_OPTIONLOADING)

export const fetchInitialOptions = () => {
    return (dispatch, getState) => {
        doPost(apiPrefixUrl, {
            "api": "ConformTypes",
            "USER_ID":"patient"
        })
        .then((data) => {
            if (data.status) {
                let conformOptions = _.map(data.data, (item, key) => ({ value: item.TYPE_ID, label: item.TYPE_NAME }))
                dispatch(setOption({ field: 'conform', options: conformOptions }))
            }
        })

        doPost(apiPrefixUrl, {
            api:'TWZip'
        })
        .then((data)=>{
            let cityOptions = _.map(data.data, (item, key)=>({value:item.City, label:item.City}))
            dispatch(setOption({ field: 'city', options: cityOptions }))
        })

        doPost(apiPrefixUrl, {
            "api":"VaccineTypes"
        })
        .then((data)=>{
            let vaccineOptions = _.map(data.data, (item, key)=>({value:item.VACCINE_NAME, label:item.VACCINE_NAME}))
            dispatch(setOption({ field: 'vaccine', options: vaccineOptions }))
        })
    }
    
}


export const getReserveType = () => {
    return (dispatch, getState) => {
     
        const conformId = getState().getIn(["form", "conformId"])
        dispatch(setOption({ field: 'reserveType', options: [] }))
        if (conformId) {
            dispatch(setOptionLoading({loading:true}))
            doPost(apiPrefixUrl, {
                "api": "SchdsetTypesV2",
                "CONFORM_TYPE":conformId,
                "SPNO":"",
                "USER_ID":"patient"
            })
                .then((data) => {
                    if (data.status) {
                        let typeOptions = _.map(data.data, (item, key) => ({ value: item.SCHD_TYPE, label: item.SCHD_TYPE_NAME }))
                        dispatch(setOption({ field: 'reserveType', options: typeOptions }))
                    }
                    dispatch(setOptionLoading({loading:false}))
                })
        }
    }
}

export const getReserveDate = () => {

    return (dispatch, getState) => {
        
        const reserveType = getState().getIn(["form", "reserveType"])
        const conformId = getState().getIn(["form", "conformId"])
        const DOSAGE_COUNT = getState().getIn(["form", "DOSAGE_COUNT"])
        const PRE_VACCINE_DATE = getState().getIn(["form", "PRE_VACCINE_DATE"])

        dispatch(setOption({ field: 'reserveDate', options: [] }))

        if (reserveType && DOSAGE_COUNT) {
            if(DOSAGE_COUNT == 1 ||( DOSAGE_COUNT  && PRE_VACCINE_DATE)){
                dispatch(setOptionLoading({loading:true}))
                doPost(apiPrefixUrl, {
                    "api": "Schdsets",
                    "type": reserveType,
                    "date": "",
                    "CONFORM_TYPE":conformId,
                    "USER_ID":"patient",
                    "DOSAGE_COUNT": DOSAGE_COUNT,
                    "SPNO":"",
                    "PRE_VACCINE_DATE":PRE_VACCINE_DATE
                })
                    .then((data) => {
                        if (data.status) {
                            let dateOptions = _.map(_.uniqBy(data.data, 'START_DATE'), (item, key) => {
                                return {
                                    value: item.START_DATE,
                                    label: `${item.START_DATE_STR} (${weeks[item.DAYS_STR]})`                                
                                }
                            })
                            dispatch(setOption({ field: 'reserveDate', options: dateOptions }))
                        }
                        dispatch(setOptionLoading({loading:false}))
                    })
            }
        }
    }
}


export const getReserveTime = () => {
    return (dispatch, getState) => {
        
        const reserveType = getState().getIn(["form", "reserveType"])
        const reserveDate = getState().getIn(["form", "reserveDate"])
        const conformId = getState().getIn(["form", "conformId"])
        const DOSAGE_COUNT = getState().getIn(["form", "DOSAGE_COUNT"])
        const PRE_VACCINE_DATE = getState().getIn(["form", "PRE_VACCINE_DATE"])

        dispatch(setOption({ field: 'reserveTime', options: [] }))

        if (reserveDate && DOSAGE_COUNT) {
            if(DOSAGE_COUNT == 1 ||( DOSAGE_COUNT  && PRE_VACCINE_DATE)){
                dispatch(setOptionLoading({loading:true}))
                doPost(apiPrefixUrl, {
                    "api": "Schdsets",
                    "type": reserveType,
                    "date": reserveDate,
                    "CONFORM_TYPE":conformId,
                    "USER_ID":"patient",
                    "DOSAGE_COUNT": DOSAGE_COUNT,
                    "SPNO":"",
                    "PRE_VACCINE_DATE":PRE_VACCINE_DATE
                })
                    .then((data) => {
                        if (data.status) {
                            // let avalibleDates = _.filter(data.data, (o) => { return o.TOT_LIMIT > o.APPOINTMENT_CNT })
                            let dateOptions = _.map(data.data, (item, key) => {
                                let dateStr =  `${item.START_DATE_STR} (${weeks[item.DAYS_STR]})`   
                                let timeStr = item.START_TIME_STR
                                let isFull = parseInt(item.TOT_LIMIT) <= parseInt(item.APPOINTMENT_CNT)

                                return {
                                    value: item.SCHD_ID,
                                    label: `${dateStr} ${timeStr}${isFull?`(滿)`:""}-剩餘${item.TOT_LIMIT-item.APPOINTMENT_CNT}人`,
                                    token: item.TOKEN,
                                    disabled: isFull 
                                }
                            })
                            dispatch(setOption({ field: 'reserveTime', options: dateOptions }))
                            dispatch(setOptionLoading({loading:false}))
                        }
                    })
            }
        }
    }
}

export const getAreaCode =()=>{
    return (dispatch, getState) => {
        const city = getState().getIn(["form", "city"])

        dispatch(setOption({ field: 'AREA_CODE', options: [] }))
        if(city){
            doPost(apiPrefixUrl, {
                api:'TWZip'
            })
            .then((data)=>{
                let cityArea = _.find(data.data, (o)=>(o.City === city))
                let areaCodeOptions = _.map(cityArea.Citys, (item, key)=>({label:item.District, value:item.ZipCode}))
                dispatch(setOption({ field: 'AREA_CODE', options: areaCodeOptions }))
            })
        }
    }
}

